module.exports = __webpack_public_path__ + "img/highlights.60f17af7.webp";